import React from "react";
import "./SafeBridgeRootComponent.scss";
import axios from "axios";
import { ENDPOINTS } from "../../js/api/_config";

const TrainingAzureSearchPostElement = ({ element }) => {

    function base64ToBlob(base64, mime) {
        const byteChars = atob(base64);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mime });
    }

 const onClickSearchPost = () => {
    const splitElements = element.Link.split("/");
    const fileName = splitElements[splitElements.length - 1];  

    const newWindow = window.open('', '_blank');
    if (!newWindow) {
        alert("Popup blocked. Please allow popups for this site.");
        return;
    }
     newWindow.document.write(`
        <html>
        <head><title>Loading PDF...</title></head>
        <body style="display: flex; align-items: center; justify-content: center; height: 100vh; margin: 0;">
            <div>
                <p style="font-family: sans-serif; font-size: 18px;">Loading PDF, please wait...</p>
                <div style="border: 4px solid #f3f3f3; border-top: 4px solid #3498db; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite;"></div>
            </div>
            <style>
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
        </body>
        </html>
    `);
    axios({
        url: ENDPOINTS.SAFE_BRIDGE_SEARCH.SAFEBRIDGE_PDF_CONTENT + fileName,
        method: 'GET',
        responseType: 'json',
        headers: {
            'authorization': localStorage.getItem("userToken")
        }
    })
    .then(response => {        
        const base64 = response.data.FileByte;
        if (!base64) {
            newWindow.document.write("No PDF data found.");
            return;
        }        
        const byteChars = atob(base64);
        const byteNumbers = new Array(byteChars.length);
        for (let i = 0; i < byteChars.length; i++) {
            byteNumbers[i] = byteChars.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/pdf' });     
        const blobUrl = URL.createObjectURL(blob);

        newWindow.document.write(`
            <title>PDF Viewer</title>
            <iframe src="${blobUrl}" width="100%" height="100%" style="border:none; position:absolute; top:0; left:0; bottom:0; right:0;"></iframe>
        `);        
        setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
    })
    .catch(err => {
        console.error("Error fetching PDF", err);
        newWindow.document.write("Error fetching PDF.");
    });
};


    return (
        // KT add class safe-bridge-post-changed
        <div className={"row safe-bridge-post safe-bridge-post-changed"}>
            <div className={"col-md-3 col-sm-3 safe-bridge-sub-data-column safe-bridge-sub-data-column-changed p-3"}>
                {/* KT add class safe-bridge-sub-data-column-changed col-sm-2  10-11-2021*/}
                <div className={"safe-bridge-post-caption safe-bridge-post-caption-changed"}>
                    {/* KT add class safe-bridge-post-caption-changed  10-11-2021*/}
                    <span>Name Of Compount</span><br/>
                </div>
                <p className="safe-bridge-post-caption-content-changed">{element.NameOfCompound}</p>
            </div>

            <div className={"col-md-2 col-sm-2 p-3 safe-bridge-sub-data-column safe-bridge-sub-data-column-changed light-background"}>
                {/* KT add class safe-bridge-sub-data-column-changed col-sm-2  10-11-2021*/}
                <div className={"safe-bridge-post-caption safe-bridge-post-caption-changed"}>
                    {/* KT add class safe-bridge-post-caption-changed  10-11-2021*/}
                    <span>CAS Number</span><br/>
                </div>
                <p className="safe-bridge-post-caption-content-changed">{element.CASNumber}</p>
            </div>

            <div className={"col-md-2 col-sm-2 safe-bridge-sub-data-column safe-bridge-sub-data-column-changed p-3"}>
                {/* KT add class safe-bridge-sub-data-column-changed col-sm-2  10-11-2021*/}
                <div className={"safe-bridge-post-caption safe-bridge-post-caption-changed"}>
                    {/* KT add class safe-bridge-post-caption-changed  10-11-2021*/}
                    <span>Analytical Method</span><br/>
                </div>
                <p className="safe-bridge-post-caption-content-changed">{element.AnalyticalMethod}</p>
            </div>

            <div className={"col-md-2  col-sm-2 p-3 safe-bridge-sub-data-column safe-bridge-sub-data-column-changed light-background"}>
                {/* KT add class safe-bridge-sub-data-column-changed col-sm-2  10-11-2021*/}
                <div className={"safe-bridge-post-caption safe-bridge-post-caption-changed"}>
                    {/* KT add class safe-bridge-post-caption-changed  10-11-2021*/}
                    <span>Method Report Number</span><br/>
                </div>
                <p className="safe-bridge-post-caption-content-changed">{element.MethodReportNumber}</p>
            </div>

            <div className={"col-md-2  col-sm-2 p-3 safe-bridge-sub-data-column safe-bridge-sub-data-column-changed"}>
                {/* KT add class safe-bridge-sub-data-column-changed col-sm-2  10-11-2021*/}
                <div className={"safe-bridge-post-caption safe-bridge-post-caption-changed"}>
                    {/* KT add class safe-bridge-post-caption-changed  10-11-2021*/}
                    <span>Quantification Limit</span>
                </div>
                <p className="safe-bridge-post-caption-content-changed">{element.QuantificationLimit}</p>
            </div>
            {/* KT add class safe-bridge-button-changed col-sm-1  10-11-2021*/}
            <div className={"col-md-1  col-sm-1 p-3 safe-bridge-button-changed"}>
                <button onClick={onClickSearchPost} className="safe-bridge-read-more-button-style">
                    <i className="fa fa-print" style={{fontSize: "20px"}}
                       aria-hidden="true"/>
                </button>
            </div>

        </div>
    )
}

function SafeBridgeSearchPostList({valueList, activePage}) {
    return (
        <div className="training-posts-container">
            {
                valueList && valueList.length > 0
                &&
                <div className={"safe-bridge-top-heading-row safe-bridge-top-heading-row-changed"}>
                    {/*KT add class safe-bridge-top-heading-row-changed 10-12-2021 */}
                    <div className={"col-md-3 col-sm-3"}>
                        {/*KT add class col-sm-3 10-12-2021 */}
                        <span className="safe-bridge-top-heading-changed">Name of Compound</span>
                    </div>

                    <div className={"col-md-2 col-sm-2"}>
                        {/*KT add class col-sm-2 10-12-2021 */}
                        <span className="safe-bridge-top-heading-changed">CAS Number</span>
                    </div>

                    <div className={"col-md-2 col-sm-2"}>
                        {/*KT add class col-sm-2 10-12-2021 */}
                        <span className="safe-bridge-top-heading-changed">Analytical Method</span>
                    </div>

                    <div className={"col-md-2 col-sm-2"}>
                        {/*KT add class col-sm-2 10-12-2021 */}
                        <span className="safe-bridge-top-heading-changed">Method Report No</span>
                    </div>

                    <div className={"col-md-2 col-sm-2"}>
                        {/*KT add class col-sm-2 10-12-2021 */}
                        <span className="safe-bridge-top-heading-changed">Quantification Limit</span>
                    </div>
                </div>
            }
            {
                valueList && valueList.slice((activePage * 10) - 10, activePage * 10)
                    .map(element => {
                        return (
                            <TrainingAzureSearchPostElement element={element}/>
                        )
                    })
            }
        </div>
    );
}

export default SafeBridgeSearchPostList;
